import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import CookieBanner from '../site/CookieBanner/CookieBanner';
import SiteNav from '../site/SiteNav/SiteNav';
import SiteFooter from '../site/SiteFooter/SiteFooter';
import { useAnalytics } from '../../analytics/useAnalytics';
import { useLanguage } from '../../i18n/useLanguage';
import styles from './layout.module.css';

export default function Layout({ children }: { children: ReactNode }) {
    const { t } = useTranslation();
    const { language } = useLanguage();
    useAnalytics();

    return (
        <div lang={language} className={styles.document}>
            <a href="#main-content" className={styles.skipLink}>
                {t('a11y.skipToContent')}
            </a>
            <SiteNav />
            <main id="main-content" className={styles.main} tabIndex={-1}>
                {children}
            </main>
            <SiteFooter />
            <CookieBanner />
        </div>
    );
}
